// extracted by mini-css-extract-plugin
module.exports = {"relatedGrid":"_3gNGcdaZ25BHcGB3VVACkS","relatedTitle":"_3d9wesOgvsHs_gSmxJwfHX","relatedLeft":"_3FURuK1d_kGtOUG5Zdp2og","relatedRight":"_2wD7nJOajfOYH85SYQZ1wL"};